module.exports = __webpack_public_path__ + "media/images/icons/link-e6d26bd6796f28c55e7ac53416bd4c01.svg";